import * as e from "react";
const c = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ES_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#ES_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#FFB400"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ES_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ES_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v6h32V0H0zM0 18v6h32v-6H0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#F1F9FF", d: "M5.008 10.271h1.12v5.824h-1.12z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.577 9.264H4.56v.56h.336v.448H6.24v-.448h.336v-.56zM6.24 16.431h.337v.56H4.56v-.56h.336v-.448H6.24v.448z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.57 9.376c.243 0 .268-.092.411-.23.112-.106.372-.238.372-.386 0-.34-.35-.616-.784-.616-.433 0-.784.275-.784.616 0 .165.18.276.315.387.142.116.247.229.47.229z",
      fill: "#AD1619"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.56 16.991h2.017v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112v-.896z",
      fill: "#005BBF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ES_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 4,
      y: 16,
      width: 3,
      height: 2
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.56 16.991h2.017v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112v-.896z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ES_svg__c)", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M4.542 17.711l-.044-.107c.182-.081.364-.122.546-.122.118 0 .18.017.285.063a.49.49 0 00.24.054.49.49 0 00.24-.054.594.594 0 01.284-.063c.182 0 .365.041.546.122l-.044.107a1.226 1.226 0 00-.502-.112.49.49 0 00-.24.054.593.593 0 01-.284.063.593.593 0 01-.284-.063.49.49 0 00-.24-.054c-.168 0-.335.037-.503.112zM4.542 17.375l-.044-.107c.182-.081.364-.122.546-.122.118 0 .18.017.285.063a.49.49 0 00.24.054.49.49 0 00.24-.054.593.593 0 01.284-.063c.182 0 .365.041.546.122l-.044.107a1.227 1.227 0 00-.502-.112.49.49 0 00-.24.054.593.593 0 01-.284.063.593.593 0 01-.284-.063.49.49 0 00-.24-.054c-.168 0-.335.037-.503.112z" })), /* @__PURE__ */ e.createElement("path", { fill: "#F1F9FF", d: "M15.984 10.271h1.12v5.824h-1.12z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.553 9.264h-2.016v.56h.336v.448h1.344v-.448h.336v-.56zM17.217 16.431h.336v.56h-2.016v-.56h.336v-.448h1.344v.448z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.546 9.376c.244 0 .268-.092.412-.23.112-.106.372-.238.372-.386 0-.34-.351-.616-.784-.616-.433 0-.784.275-.784.616 0 .165.179.276.314.387.143.116.248.229.47.229z",
      fill: "#AD1619"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.537 16.991h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112v-.896z",
      fill: "#005BBF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ES_svg__d",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 15,
      y: 16,
      width: 3,
      height: 2
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.537 16.991h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112v-.896z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ES_svg__d)", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M15.519 17.711l-.044-.107c.181-.081.363-.122.546-.122.118 0 .18.017.284.063a.49.49 0 00.24.054.49.49 0 00.24-.054.594.594 0 01.285-.063c.182 0 .364.041.546.122l-.044.107a1.225 1.225 0 00-.502-.112.49.49 0 00-.24.054.593.593 0 01-.285.063.593.593 0 01-.284-.063.49.49 0 00-.24-.054c-.167 0-.334.037-.502.112zM15.519 17.375l-.044-.107c.181-.081.363-.122.546-.122.118 0 .18.017.284.063a.49.49 0 00.24.054c.1 0 .148-.013.24-.054a.593.593 0 01.285-.063c.182 0 .364.041.546.122l-.044.107a1.227 1.227 0 00-.502-.112.49.49 0 00-.24.054.593.593 0 01-.285.063.593.593 0 01-.284-.063.49.49 0 00-.24-.054c-.167 0-.334.037-.502.112z" })), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.989 15.68c.202-.245.315-.468.315-.704a.633.633 0 00-.123-.383l.014-.006c-.002 0 .221-.097.299-.134a2.47 2.47 0 00.395-.232c.079-.058.185-.12.346-.207l.152-.08.04-.023c.08-.041.138-.074.192-.105.17-.098.28-.18.366-.288a.535.535 0 00-.123-.798c-.139-.095-.327-.149-.602-.192l-.056-.008-.337-.053c-.132-.02-.249-.04-.354-.058.689-.114 1.672-.072 2.105.151l.41-.796c-.88-.455-2.889-.409-3.639.108-.55.379-.476.951.096 1.198.24.103.551.172 1.128.264a2.867 2.867 0 00-.251.162 1.597 1.597 0 01-.256.15c-.047.022-.186.083-.25.11l-.032.015c-.467.212-.693.505-.625 1.035l.036.287.066.02.688.567zm-.577-.74l-.002.004.001-.003v-.002zm12.294.036c0 .236.113.46.315.704l.688-.567.065-.02.037-.287c.068-.53-.159-.823-.625-1.035l-.032-.014-.25-.112a1.601 1.601 0 01-.256-.149 2.865 2.865 0 00-.251-.162c.577-.092.888-.16 1.128-.264.572-.247.646-.82.096-1.198-.75-.517-2.758-.563-3.64-.108l.411.796c.433-.223 1.416-.265 2.105-.15-.105.017-.223.037-.354.057l-.337.053-.057.008c-.275.043-.462.097-.601.192a.535.535 0 00-.124.798c.086.109.198.19.367.288.054.031.113.064.191.105l.04.022.153.08c.161.088.267.15.346.208.124.09.251.163.395.232.078.037.3.134.3.134l.012.006a.633.633 0 00-.122.383z",
      fill: "#AD1619"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.923 12.4l.33.068v.492c-.351.281-1.245.755-1.245.755v-1.316h.915zM16.315 12.4l-.33.068v.492c.352.281 1.245.755 1.245.755v-1.316h-.915z",
      fill: "#F1F9FF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.777 7.206v-.164c-.577-.414-1.18-.62-1.81-.62a3.613 3.613 0 00-1.835-.312v-.002c-.93-.092-1.869.314-1.869.314-.946 0-1.81.62-1.81.62v.164l1.13 1.135s.318 1.091 2.544.835v.002s1.474-.04 1.578-.074c.041-.014.084-.026.127-.04.289-.083.619-.18.815-.724l1.13-1.134zm-3.65-1.038c-.034.398-.213 2.645 0 3v-3z",
      fill: "#AD1619"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.316 8.15l.001-.004-.796-.748.077-.082.747.703.019-.089a.95.95 0 00.263.031v-.152l.165.09c.082.043.198.055.352.03.112-.018.188-.149.213-.428l.05-.563.169.54c.076.244.192.351.357.351.162 0 .227-.059.234-.208l.02-.423.192.378c.069.136.164.198.3.198.192 0 .322-.161.322-.415h.227c0 .254.129.415.322.415.136 0 .23-.062.3-.198l.191-.378.02.423c.008.15.073.208.234.208.166 0 .282-.107.358-.351l.168-.54.05.563c.025.279.101.41.214.428.153.025.27.013.351-.03l.165-.09v.152a.95.95 0 00.263-.03l.036.163.826-.778.077.082-1.028.966c-.15.277-.225.459-.225.534 0 .116-.3.184-.887.255-.46.055-1.002.092-1.445.097v.001h-.112a14.44 14.44 0 01-1.445-.098c-.586-.07-.887-.14-.887-.255a.234.234 0 00-.008-.053.882.882 0 01-.129-.311 5.68 5.68 0 00-.088-.17L8.32 8.15h-.005zm5.506.017c-.184.033-.317.03-.387-.028a.88.88 0 01-.386.011c-.157-.025-.267-.13-.333-.303a.513.513 0 01-.326.199c.717.102 1.22.244 1.22.244s-.013.11-.044.236c.032-.067.07-.14.115-.223l.011-.014.13-.122zm-1.768-.163a.36.36 0 01-.149-.135.499.499 0 01-.183.104c.114.008.225.019.332.03zm-.725-.053a.512.512 0 01-.215-.188.513.513 0 01-.212.187c.05-.002.102-.003.154-.003h.09c.061 0 .122.002.183.004zm-2.705.33l-.105-.098c.126.013.22 0 .274-.044a.88.88 0 00.387.011c.157-.025.266-.13.332-.303a.514.514 0 00.314.197c-.618.086-1.08.205-1.202.238zm1.877-.31c-.109.008-.215.018-.32.029a.359.359 0 00.143-.13c.052.046.111.08.177.101zm2.753.93c.08.037.143 0 .193-.073a.373.373 0 00-.008.055.192.192 0 01-.03.015 1.084 1.084 0 01-.167.049c-.144.033-.349.065-.592.095-.475.057-1.04.094-1.49.097a14.191 14.191 0 01-1.486-.097 6.131 6.131 0 01-.592-.095 1.264 1.264 0 01-.147-.041.18.18 0 00.012-.005c.244-.115 1.862-.222 2.154-.24.291.018 1.909.125 2.153.24zm.309-.021l-.002.002V8.88h.002z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.113 5.347a.336.336 0 100-.672.336.336 0 000 .672z",
      fill: "#005BBF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.894 6.996a.443.443 0 00.033.103.425.425 0 00-.15-.027c-.155 0-.28.076-.28.168 0 .093.125.168.28.168.154 0 .28-.075.28-.168v-.005.005c0 .093.125.168.28.168.155 0 .28-.075.28-.168 0-.092-.125-.168-.28-.168a.444.444 0 00-.11.014.426.426 0 00-.003-.154c-.03-.152-.128-.26-.219-.243-.09.018-.14.155-.111.307zm-1.648.214a.446.446 0 01-.032-.101c-.03-.152.02-.29.112-.307.09-.018.188.09.218.242.01.055.01.107.003.153a.444.444 0 01.11-.013c.155 0 .28.075.28.168 0 .092-.125.168-.28.168-.154 0-.28-.076-.28-.168v-.005.005c0 .092-.126.168-.28.168-.155 0-.28-.076-.28-.168 0-.093.125-.168.28-.168.055 0 .106.01.15.026zm3.508.103c-.013.092-.147.149-.3.127-.154-.021-.267-.113-.254-.205.013-.092.147-.15.3-.128a.423.423 0 01.147.048.447.447 0 01-.018-.107c-.008-.154.06-.283.153-.288.092-.005.174.116.182.27a.424.424 0 01-.019.153.444.444 0 01.11.003c.153.021.267.113.254.205-.013.092-.148.149-.3.127-.154-.021-.268-.113-.255-.205l.001-.006v.006zm1.068.444c.137.073.283.065.326-.017l.002-.004a.11.11 0 00.047.03c.09.027.198-.07.243-.219.045-.148.01-.29-.079-.317-.089-.027-.197.071-.242.219a.446.446 0 00-.02.104.426.426 0 00-.119-.092c-.137-.073-.283-.065-.326.017-.044.081.032.207.168.28zm-5.495.035c-.137.072-.283.065-.326-.017a.103.103 0 01-.003-.006.11.11 0 01-.048.031c-.089.027-.198-.07-.243-.219-.045-.148-.01-.29.079-.317.089-.027.197.071.243.22a.445.445 0 01.019.106.423.423 0 01.121-.095c.137-.073.283-.065.326.017.044.082-.032.207-.168.28zM10.988 4.076h.234v.148h.153v.233h-.153v.467h.153v.233h-.541v-.233h.154v-.467h-.154v-.233h.154v-.148z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#C88A02", d: "M10.945 5.344h.448V6.8h-.448z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.142 5.587L9.14 5.7c-.993-.017-1.563.128-1.707.417-.15.298-.122.661.088 1.093l-.101.049c-.224-.46-.254-.86-.087-1.192.171-.343.774-.497 1.81-.479z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.335 6.58l-.057.097c-.217-.129-.325-.35-.325-.653 0-.437.225-.693.722-.868.318-.111.751-.066 1.302.134l-.038.105c-.529-.191-.938-.235-1.226-.133-.457.16-.648.378-.648.762 0 .266.09.45.27.557z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.662 7.037l-.212.075c-.219-.625-.156-1.049.218-1.232.33-.16.812-.226 1.446-.2l-.009.223c-.6-.024-1.048.037-1.338.179-.247.12-.292.425-.105.955z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.13 5.439c-.511 0-.722.125-.842.493-.076.235-.002.435.239.622l-.138.177c-.311-.242-.421-.539-.314-.869.153-.469.454-.647 1.056-.647.394 0 .702.104.916.314l.033.033v1.08h-.224v-.984c-.167-.145-.407-.22-.725-.22z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.051 5.7l.002.112c.993-.018 1.563.127 1.707.416.15.299.122.662-.087 1.093l.1.049c.224-.46.255-.859.088-1.192-.172-.343-.775-.496-1.81-.478z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.7 6.604l.058.097c.216-.13.324-.35.324-.654 0-.436-.225-.692-.722-.867-.318-.112-.751-.066-1.302.134l.038.105c.529-.192.938-.235 1.227-.134.456.161.647.379.647.762 0 .267-.09.45-.27.557z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.6 7.15l.211.074c.22-.624.157-1.048-.218-1.231-.33-.162-.811-.227-1.446-.201l.01.223c.6-.024 1.047.037 1.338.179.246.12.291.425.105.956z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.12 5.456c.511 0 .722.125.842.493.076.235.002.435-.239.622l.138.177c.311-.242.421-.538.314-.868-.153-.47-.454-.648-1.056-.648-.394 0-.702.104-.916.315l-.033.033v1.08h.224v-.984c.167-.146.407-.22.725-.22z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.3,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.473 9.264h7.28v6.54S14.212 18 11.113 18c-3.1 0-3.64-2.253-3.64-2.253V9.264z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ES_svg__e",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 7,
      y: 9,
      width: 8,
      height: 9
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.473 9.264h7.28v6.54S14.212 18 11.113 18c-3.1 0-3.64-2.253-3.64-2.253V9.264z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ES_svg__e)" }, /* @__PURE__ */ e.createElement("path", { fill: "#FFC034", d: "M7.473 13.296h3.696v4.368H7.473z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#AD1619",
      d: "M7.92 13.52h.448v4.144H7.92zM9.488 13.52h.448v4.144h-.448zM8.705 13.52h.448v4.144h-.448zM10.273 13.52h.448v4.144h-.448zM7.473 9.151h3.696v4.256H7.473z"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#AD1619", d: "M11.057 13.184h3.696v4.256h-3.696z" }), /* @__PURE__ */ e.createElement("path", { fill: "#F1F9FF", d: "M11.057 9.264h3.92v4.144h-3.92z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.04 9.6h.335v.928H9.6v-.463h.336v.463h.336v.581h-.336v1.046h.336v.581H8.256v-.58h.336v-1.047h-.336v-.58h.224v-.464h.336v.463h.223V9.6z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.979 9.794l.229-.245.481.45-.229.245-.482-.45z",
      fill: "#C88A02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.36 16.14v-2.453h-2.8v2.432l.005.019c.142.604.624.91 1.396.91.77 0 1.253-.298 1.395-.889l.005-.02zm-1.4.572c-.618 0-.956-.209-1.064-.633v-2.056h2.128V16.1c-.107.41-.444.613-1.063.613z",
      fill: "#FFC034"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.075 13.893h-.233v1.11l-.919-1-.165.152.832.905h-.754v.336h.772l-.85.925.165.151.92-1v1.3h.232v-1.184l.814.885.164-.152-.85-.925h.95v-.336h-.932l.832-.905-.165-.151-.813.884v-.995z",
      fill: "#FFC034"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.483 17.442s-2.372.187-2.372-1.343c0 0-.023 1.343-2.5 1.343v1.208h4.872v-1.208z",
      fill: "#F1F9FF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.113 14.191c.464 0 .84-.4.84-.896 0-.494-.376-.896-.84-.896-.463 0-.84.402-.84.896 0 .495.377.896.84.896z",
      fill: "#005BBF",
      stroke: "#AD1619",
      strokeWidth: 1.167
    }
  ))))
);
export {
  c as default
};
